import { Tag } from '@carbon/react';
import { OUTCOME_LABEL, OUTCOME_TAG_TYPE } from './utils';
import type { AutoMatchOutcome } from './types';

/**
 * A decision's outcome as a coloured tag.
 * @param {object} props - The outcome
 * @param {AutoMatchOutcome} props.outcome - Auto-confirmed or manual review
 * @return {JSX.Element} The tag
 */
export function OutcomeTag({ outcome }: { outcome: AutoMatchOutcome }) {
  return (
    <Tag type={OUTCOME_TAG_TYPE[outcome]} size="sm">
      {OUTCOME_LABEL[outcome]}
    </Tag>
  );
}
